/* eslint-disable no-return-await */
import getContract from './getContract';

const getWallet = async () => {
  const contract = getContract();

  const accounts = await web3Client.eth.getAccounts();

  return await contract.methods.tokensOfOwner(accounts[0]).call();
};

export default getWallet;
